import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import type { User } from '@supabase/supabase-js';

interface AdminHeaderProps {
  user: User;
}

export default function AdminHeader({ user }: AdminHeaderProps) {
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  };

  return (
    <header
      className="h-16 flex items-center justify-between px-6 md:px-10 shrink-0"
      style={{ background: '#0B2F5B', borderBottom: '1px solid rgba(201,162,74,0.2)' }}
    >
      {/* Brand */}
      <div className="flex items-center gap-3">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center"
          style={{ background: 'rgba(201,162,74,0.15)' }}
        >
          <i className="ri-shield-keyhole-line text-sm" style={{ color: '#C9A24A' }} />
        </div>
        <span className="font-serif font-bold text-base" style={{ color: '#FFFFFF' }}>
          LC Advogados
          <span className="ml-2 text-xs font-sans font-normal px-2 py-0.5 rounded-full" style={{ background: 'rgba(201,162,74,0.15)', color: '#C9A24A' }}>
            Admin
          </span>
        </span>
      </div>

      {/* User + logout */}
      <div className="flex items-center gap-4">
        <div className="hidden sm:flex items-center gap-2">
          <div
            className="w-7 h-7 rounded-full flex items-center justify-center"
            style={{ background: 'rgba(201,162,74,0.15)' }}
          >
            <i className="ri-user-line text-xs" style={{ color: '#C9A24A' }} />
          </div>
          <span className="text-xs" style={{ color: 'rgba(255,255,255,0.6)' }}>
            {user.email}
          </span>
        </div>
        <button
          onClick={handleLogout}
          disabled={loggingOut}
          className="flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:opacity-80 disabled:opacity-50"
          style={{ background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.8)' }}
        >
          <i className="ri-logout-box-r-line" />
          {loggingOut ? 'Saindo...' : 'Sair'}
        </button>
      </div>
    </header>
  );
}
